import { NavLink } from 'react-router-dom';

import { useAuth } from '../../features/auth/useAuth';
import { cn } from '../../lib/cn';
import { ROLE_LABELS } from '../../lib/labels';
import { Brand } from './Brand';
import { type NavItem } from './nav-items';
import { usePlayerNav } from './use-player-nav';

const linkClass = ({ isActive }: { isActive: boolean }) =>
  cn(
    'flex min-h-11 items-center gap-3 rounded-control px-3 text-sm font-medium transition-colors',
    isActive
      ? 'bg-[#E3F1E8] font-semibold text-brand'
      : 'text-ink-muted hover:bg-surface-raised hover:text-ink',
  );

function NavList({ items, label }: { items: readonly NavItem[]; label?: string }) {
  return (
    <div className="flex flex-col gap-1">
      {label ? (
        <p className="px-3 pt-4 pb-1 text-xs font-semibold tracking-wider text-ink-faint uppercase">
          {label}
        </p>
      ) : null}
      {items.map(({ to, label: itemLabel, icon: Icon, end }) => (
        <NavLink key={to} to={to} end={end} className={linkClass}>
          <Icon className="size-5 shrink-0" />
          {itemLabel}
        </NavLink>
      ))}
    </div>
  );
}

/** Desktop navigation. Hidden below `lg`, where the bottom tab bar takes over. */
export function Sidebar() {
  const { user } = useAuth();
  const nav = usePlayerNav();

  return (
    <aside className="sticky top-0 hidden h-dvh w-[248px] shrink-0 flex-col border-r border-line bg-surface px-3 py-5 lg:flex">
      <div className="px-2 pb-4">
        <Brand />
      </div>

      <nav aria-label="Основная навигация" className="flex-1 overflow-y-auto" data-scroll-shadow>
        <NavList items={nav} />
      </nav>

      <div className="mt-4 rounded-control border border-line bg-surface px-3 py-2.5">
        <p className="truncate text-sm font-semibold text-ink">{user?.name}</p>
        <p className="truncate text-xs text-ink-faint">{user ? ROLE_LABELS[user.role] : ''}</p>
      </div>
    </aside>
  );
}
